import { LoggerProvider } from "@pureweb/platform-sdk";
export default LoggerProvider.getLogger("client");
